import React, { PropsWithChildren, useEffect, useState } from 'react'
import {
  DropDownListBlurEvent,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import DropdownOption from './DropdownOption';
import SearchableDropdown from './SearchableDropdown';
import { ServiceTypeService } from '../../services';
import { ServiceTypeModel } from '../../data/entities';

interface SearchableServiceTypeDropdownProps extends PropsWithChildren {
  value?: any;
  name: string;
  isInvalid?: boolean;
  onBlur?: (e: DropDownListBlurEvent) => void;
  onChange?: (e: DropDownListChangeEvent) => void;
  onSelect?: (value: DropdownOption) => void;
  placeholder?: string;
}

export const SearchableServiceTypeDropdown = React.forwardRef(
  (
    props: Readonly<SearchableServiceTypeDropdownProps>,
    ref: React.ForwardedRef<HTMLSelectElement | null>
  ) => {
    const serviceTypeService = new ServiceTypeService();
    const [options, setOptions] = useState<DropdownOption[]>([]);

    useEffect(() => {
      const fetchData = async () => {
        
        let services = await serviceTypeService.getAll();

        const newOptions = services
          .map<DropdownOption>((serviceType: ServiceTypeModel) => ({
            value: serviceType.id?.toString() ?? "",
            text: `${serviceType.name}`,
          }))
          .sort((a, b) => a.text.localeCompare(b.text));

        setOptions(newOptions);
      };

      fetchData();
    }, []);

    const getValue = () => {
      if (props.value) {
        return options.find((option) => option.value === props.value?.toString());
      }
    }

    return (
      <SearchableDropdown
        defaultItem={{ text: "Select a Service Type", value: "" }}
        label="Service Type"
        name={props.name}
        options={options}
        value={getValue()}
        onChange={props.onChange}
        onSelect={props.onSelect}
        isInvalid={props.isInvalid}
      >
        {props.children}
      </SearchableDropdown>
    );
  }
);

export default SearchableServiceTypeDropdown
